import { Components, Theme } from '@mui/material'

export const MuiDivider: Components<Omit<Theme, 'components'>>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.futureTheme.border.strong,
    }),
  },
  variants: [
    {
      props: { orientation: 'vertical' },
      style: ({ theme }) => ({
        borderRightWidth: theme.futureTheme.strokeWidth.default,
      }),
    },
    {
      props: { orientation: 'horizontal' },
      style: ({ theme }) => ({
        borderBottomWidth: theme.futureTheme.strokeWidth.default,
      }),
    },
  ],
}
